export const CampaignRoute = {
  path: '*',
  props: true,
  redirect: {
    name: 'Landing'
  }
  // components: {
  //   default: () =>
  //     import(/* webpackChunkName: "campaign-layout" */ '../CampaignLayout.vue'),
  //   overlay: () =>
  //     import(
  //       /* webpackChunkName: "overlay-tournament-catalog" */ '../components/CampaignFooter.vue'
  //     )
  // },
  // children: [
  //   {
  //     path: '',
  //     name: 'CNY2021Home',
  //     props: true,
  //     component: () =>
  //       import(
  //         /* webpackChunkName: "campaign-view" */ '../views/CNY2021Home.vue'
  //       ),
  //     meta: {
  //       title: '福牛利是'
  //     }
  //   },
  //   {
  //     path: 'missions',
  //     name: 'CNY2021DailyMissions',
  //     props: true,
  //     component: () =>
  //       import(
  //         /* webpackChunkName: "campaign-view" */ '../views/CNY2021DailyMissions.vue'
  //       ),
  //     meta: {
  //       title: '福牛任務'
  //     }
  //   },
  //   {
  //     path: 'records',
  //     name: 'CNY2021Records',
  //     props: true,
  //     component: () =>
  //       import(
  //         /* webpackChunkName: "campaign-view" */ '../views/CNY2021Records.vue'
  //       ),
  //     meta: {
  //       title: '抽獎記錄'
  //     }
  //   }
  // ]
}

export default {
  path: '/',
  redirect: {
    name: 'Landing'
  },
  // component: () =>
  //   import(
  //     /* webpackChunkName: "app-layout" */ '@/modules/shared/AppLayout.vue'
  //   ),
  children: [CampaignRoute]
}
